// Lista de permissões

const permItemtrabalho = [
  'add_itemtrabalho',
  'change_itemtrabalho',
  'delete_itemtrabalho',
  'view_itemtrabalho',
  'enviar_itemtrabalho',
  'concluir_itemtrabalho'
]

const permReporteAndamento = [
  'concluir_revisao_reporteandamento',
  'solicitar_revisao_reporteandamento',
  'validar_reporteandamento',
  'enviar_reporteandamento',
  'view_reporteandamento',
  'delete_reporteandamento',
  'change_reporteandamento',
  'add_reporteandamento',
  'devolver_reporteandamento'
]

const permResumo = [
  'add_resumo',
  'change_resumo',
  'delete_resumo',
  'view_resumo',
  'enviar_resumo',
  'validar_resumo',
  'solicitar_revisao_resumo',
  'concluir_revisao_resumo'
]

const permPauta = [
  'add_pauta',
  'change_pauta',
  'delete_pauta',
  'view_pauta'
]

const permRelator = [
  'add_relator',
  'pode_ser_relator'
]

export const permissions = [
  ...permItemtrabalho,
  ...permReporteAndamento,
  ...permResumo,
  ...permPauta,
  ...permRelator
]
